<template>
    <div>
        <a-form-model
            ref="addInventoryTransferForm"
            :model="addInventoryTransferModel"
            :rules="rules"
        >
        <a-row>
            <a-col :span="22" :offset="1">
                <a-form-model-item label="Transfer To" ref="distributionCenterId" prop="distributionCenterId">
                    <a-select v-model="addInventoryTransferModel.distributionCenterId" placeholder="please select your option">
                        <a-select-option v-for="center in availableDistCenters" :key="center.id" v-bind:value="center.id">
                            {{ center.name }}
                        </a-select-option> 
                    </a-select>
                </a-form-model-item>
            </a-col>
        </a-row>
        <div ref="productHeight" style="height: 200px; overflow-y: scroll">
            <a-row 
            v-for="(request, index) in addInventoryTransferModel.request"
            :key="request.key"
            type="flex" 
            justify="space-around"
            >
            <a-col :span="11" >
                <a-form-model-item 
                    label="Product Name" 
                    :prop="'request.' + index + '.productId'"
                    :rules="{
                        required: true,
                        message: 'Please choose your option',
                        trigger: 'change',
                    }"
                    >
                    <a-select
                        @change="(e) => onChangeProduct(request, e)"
                        show-search
                        placeholder="Choose your product"
                        option-filter-prop="children"
                        v-model="request.productId"
                        :filter-option="filterOption"
                    >
                        <a-select-option v-for="product in filteredProducts" :key="product.productId" v-bind:value="product.productId">
                            {{product.productBrandName}}
                        </a-select-option>
                    </a-select>
                    
                </a-form-model-item>
            </a-col>
            <a-col :span="2">
                <a-form-model-item 
                    label="Quantity" 
                    :prop="'request.' + index + '.quantity'"
                    :rules="[
                        {
                            required: true,
                            message: 'Please enter your quantity',
                            trigger: 'change',
                        },
                        
                    ]"
                    >
                        <a-input-number 
                            :min="1" 
                            :max="request.balance"
                            class="rightSideinputText"
                            type="number"
                            @change="(e) => onChangeQuantity(request, e)"
                            v-model="request.quantity"
                        />
                </a-form-model-item>
            </a-col>
            <a-col :span="4">
                <div style="margin-top: 53px;display:flex;justify-content: space-around">
                    <a-icon
                        v-if="addInventoryTransferModel.request.length > 1"
                        class="dynamic-delete-button"
                        type="minus-circle-o"
                        :disabled="addInventoryTransferModel.request.length === 1"
                        @click="removeDomain(request)"
                    />
                </div>
            </a-col>
        </a-row>
        </div>
            
        <a-form-model-item class="pt-4" >
            <a-button :disabled="filteredProducts.length === 0"  style="margin:0 auto;float: right; background:#418a49; color:#fff;" @click="addDomain">
                <a-icon type="plus" /> Add Product
            </a-button>
        </a-form-model-item>
        <a-row>
            <a-col :span="22" :offset="1">
                <a-form-model-item label="Notes" ref="notes" prop="notes">
                    <a-textarea
                        v-model="addInventoryTransferModel.notes"
                        placeholder="Enter notes...."
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                />
                </a-form-model-item>
            </a-col>
        </a-row>

        <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
            <a-button  @click="handleAddInventoryTransfer" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                Add Replenishment Request
            </a-button>
        </a-form-model-item>

        </a-form-model>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { NotificationMixins } from "@/mixins/NotificationMixins";
    export default {
        name: 'AddInventoryTransferForm',
        mixins: [NotificationMixins],
        props: ['locationId'],
        data(){
            return{
                availableProducts:[],
                filteredProducts:[],
                availableDistCenters:[],
                tableLoading: false,
                wareHouseLocationId: this.locationId,
                addInventoryTransferModel:{
                    request:[
                        {
                            productId:'',
                            quantity: '',
                            balance: 0,
                            key: Date.now()
                        }
                    ],
                    notes: '',
                    distributionCenterId: '',
                },
                rules: {
                    productId: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    quantity: [
                        { required: true, message: 'Please enter your quantity', trigger: 'change' },
                        {
                                pattern: new RegExp(/^[1-9]\d*$/),
                                message: 'Please enter valid number',
                                trigger: 'change'
                        },
                    ],
                    distributionCenterId: [
                        { required: true, message: 'Please select where your products will be transfered to', trigger: 'change' }
                    ],
                },
            }
        },
        methods:{
            ...mapActions(['getAllDistributionCenters', 'getAllInventoryProducts']),
            addDomain() {
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if(valid){
                        this.checkExistingProducts()
                        if(this.filteredProducts.length !== 0) {
                            this.addInventoryTransferModel.request.push({
                                productId: '',
                                quantity: '',
                                balance: 0,
                                key: Date.now()
                            });
                            this.scrollToEnd();
                        }
                    }else{
                        return false;
                    }
                })
            },
            scrollToEnd: function() { 
                const container = this.$refs.productHeight;
                container.scrollTop = container.scrollHeight;
            },
            removeDomain(item) {
                let index = this.addInventoryTransferModel.request.indexOf(item);
                if (index !== -1) {
                    this.addInventoryTransferModel.request.splice(index, 1);
                }
                this.checkExistingProducts()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onChangeQuantity(request, quantity){
            
                let index = this.addInventoryTransferModel.request.indexOf(request);
                if(index !== -1){
                    let item = this.addInventoryTransferModel.request[index]

                    if(!item.productId){
                        this.showErrorAlert("Kindly select product")
                    }else{
                        if(!(quantity <= item.balance)){
                            this.showErrorAlert(`You've exceeded the quantity. Kindly choose between 1 to ${item.balance}`)
                        }
                    }
                }
            },
            checkExistingProducts(){
                const selectedProducts = this.addInventoryTransferModel.request.map(product => product.productId)
                const products = [];
                this.availableProducts.forEach(product => {
                    if(!(selectedProducts.includes(product.productId))){
                        products.push(product)
                    }
                })
                this.filteredProducts = products
            },
            onChangeProduct(request,productId){
                if(request.productId === productId){
                    const product = this.filteredProducts.find(product => product.productId === productId)
                    if(product){
                        let index = this.addInventoryTransferModel.request.indexOf(request);
                        let item = this.addInventoryTransferModel.request[index]
                        item.balance = product.balance
                        this.addInventoryTransferModel.request[index] = item
                    }
                }
            },
            handleAddInventoryTransfer(){
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let productQuantity = {};

                        this.addInventoryTransferModel.request.forEach(product => {
                            productQuantity[product.productId] = product.quantity
                        })
                        const request = {
                            destinationLocationId: this.addInventoryTransferModel.distributionCenterId,
                            data: {
                                sourceLocationId: this.wareHouseLocationId,
                                items: productQuantity,
                                notes: this.addInventoryTransferModel.notes 
                            }                  
                        }
                        this.$emit('inventoryRequest',request)    
                        this.$refs.addInventoryTransferForm.resetFields();
                        this.addInventoryTransferModel.request = []
                        this.addInventoryTransferModel.request.push({
                                productId:'',
                                quantity: '',
                                balance: 0,
                                key: Date.now()
                        })    
                        this.loadInventoryProductsAndDistCenters()      
                        this.loading = false;     
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            async loadAllDistributionCenters(response){
                if(response.status === 200){
                    this.availableDistCenters = await response.data.data
                }else{
                console.log("Error 2| " , response)
                }
            },
            async loadAllInventoryProducts(response){    
                 if(response.status === 200){
                    const result = await response.data.filter(inventory => inventory.balance > 0)
                    this.availableProducts = result
                    this.filteredProducts = result
                    
                }else{
                console.log("Error 2| " , response)
                }
            },
            async loadInventoryProductsAndDistCenters(){
                const centers = await this.getAllDistributionCenters()
                const inventories = await this.getAllInventoryProducts(this.wareHouseLocationId)

                // console.log("inventories | " , inventories)
                this.loadAllInventoryProducts(inventories)
                this.loadAllDistributionCenters(centers)
            }
        },
        created() {
            // console.log("created")
          
        //   if(this.getAllStockAdjustmentData){
        //       this.getAllStockAdjustmentData();
        //   }
          if(this.loadInventoryProductsAndDistCenters){
              this.loadInventoryProductsAndDistCenters()
          }
        },
        
        watch: {
        locationId: {
        immediate: true,
        handler(newValue) {
            this.wareHouseLocationId = newValue
        },
        },
    },
    }
</script>

<style lang="scss" scoped>

</style>